// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "439c4348",
    "hash": "439c4348",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "439c4348",
    "semverString": null,
    "version": "2026.6.0.8"
};
/* tslint:enable */
